"use client";
import Image from "next/image";
import Link from "next/link";
import { LanguageSwitcher } from "../language-switcher";
import { Button } from "../ui/button";
import { Download, Menu } from "lucide-react";
import { useLanguage } from "@/lib/language-context";
import { BIGQUIZ_PROFILE_URL } from "@/lib/store-links";

export default function Header() {
  const { t } = useLanguage();
  return (
    <header className="sticky top-0 z-50 bg-[#F7F4EA]/90 backdrop-blur-md">
      <div className="container mx-auto flex items-center justify-between gap-4 px-4 py-4">
        <Link href="/" className="flex min-w-0 items-center gap-3">
          <Image
            src="/logo.png"
            alt="BigQuiz Logo"
            width={42}
            height={42}
            className="rounded-full"
          />
          <span className="truncate text-2xl font-black text-[#111111]">
            BigQuiz
          </span>
        </Link>
        <nav className="hidden items-center gap-6 md:flex">
          <Link
            href="#features"
            className="text-sm font-black text-[#706D65] transition-colors hover:text-[#111111]"
          >
            {t("nav.features")}
          </Link>
          <Link
            href="/download"
            className="text-sm font-black text-[#706D65] transition-colors hover:text-[#111111]"
          >
            {t("nav.download")}
          </Link>
          <Link
            href="#about"
            className="text-sm font-black text-[#706D65] transition-colors hover:text-[#111111]"
          >
            {t("nav.about")}
          </Link>
        </nav>
        <div className="flex items-center gap-2">
          <LanguageSwitcher profileHref={BIGQUIZ_PROFILE_URL} />
          <Button
            asChild
            className="hidden rounded-full bg-[#111111] font-black text-white hover:bg-[#2A2A2A] sm:inline-flex"
          >
            <Link href="/download">
              <Download className="mr-2 h-4 w-4" />
              {t("nav.notifyMe")}
            </Link>
          </Button>
          <Button
            variant="outline"
            size="icon"
            className="rounded-full border-[#E5E2D9] bg-white md:hidden"
          >
            <Menu className="h-4 w-4" />
            <span className="sr-only">{t("nav.openNavigation")}</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
